import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../../../config';
import { prepareHeaders } from './utils';

export const accountsApi = createApi({
    reducerPath: 'accountsApi',
    baseQuery: fetchBaseQuery({ baseUrl: config.backend.ACCOUNTS_SERVICE, prepareHeaders }),
    endpoints: build => ({
        fetchAccountName: build.query<string | undefined, { accountId: string }>({
            query: ({ accountId }) => `/${accountId}`,
            transformResponse: response => {
                if (
                    typeof response === 'object' &&
                    response !== null &&
                    'name' in response &&
                    typeof response.name === 'string'
                ) {
                    return response.name;
                } else {
                    return undefined;
                }
            },
        }),
    }),
});

export const { useFetchAccountNameQuery } = accountsApi;
